export default __webpack_public_path__ + "static/media/ai_left_bg.653f41d2.png";